import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Layout from '../Layout';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import MealsTable from './MealsTable';
import RecipesTable from './RecipesTable';
import IngredientsTable from './IngredientsTable';
import TypesTable from './TypesTable';
import UnitTable from './UnitTable';
import SearchField from '../../../components/common/SearchField';
import showAlert from '../../../components/common/showAlert';
import { exportClients } from '../../../redux/slices/admin/clientsSlice';

import {
  fetchMeals,
  deleteMeal,
  clearMessages as clearMealMessages
} from '../../../redux/slices/admin/mealsSlice';
import {
  fetchRecipes,
  deleteRecipe,
  clearMessages as clearRecipeMessages
} from '../../../redux/slices/admin/recipesSlice';
import {
  fetchTypes,
  deleteType,
  clearMessages as clearTypeMessages
} from '../../../redux/slices/admin/typesSlice';
import {
  fetchUnits,
  deleteUnit,
  clearMessages as clearUnitMessages
} from '../../../redux/slices/admin/unitsSlice';
import {
  fetchIngredients,
  deleteIngredient,
  clearMessages as clearIngredientMessages
} from '../../../redux/slices/admin/ingredientsSlice';

import iconPlus from '../../../images/icon-plus-symbol.svg';
import MealModal from './MealModal';
import RecipeModal from './RecipeModal';
import IngredientModal from './IngredientModal';
import TypeModal from './TypeModal';
import UnitModal from './UnitModal';

import iconPrinter from '../../../images/icon-printer.svg';
import iconDownload from '../../../images/icon-download.svg';

const Nutritions = () => {
  const [activeTab, setActiveTab] = useState('meals');
  const [isMealModalOpen, setIsMealModalOpen] = useState(false);
  const [isRecipeModalOpen, setIsRecipeModalOpen] = useState(false);
  const [isIngredientModalOpen, setIsIngredientModalOpen] = useState(false);
  const [isTypeModalOpen, setIsTypeModalOpen] = useState(false);
  const [isUnitModalOpen, setIsUnitModalOpen] = useState(false);
  const [currentSearchTerm, setCurrentSearchTerm] = useState('');
  const [typeId, setTypeId] = useState('');

  const mealTypes = useSelector((state) => state.app_options?.meal_types_min);

  const [formData, setFormData] = useState({
    name: '',
    protein: '',
    fats: '',
    carbs: '',
    instructions: '',
    picture: null,
  });

  const [isEditMode, setIsEditMode] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  const successMessage = useSelector(state => {
    switch (activeTab) {
        case 'meals':
            return state.admin_meals?.successMessage;
        case 'recipes':
            return state.admin_recipes?.successMessage;
        case 'ingredients':
            return state.admin_ingredients?.successMessage;
        case 'types':
            return state.admin_types?.successMessage;
        case 'units':
            return state.admin_units?.successMessage;
        default:
            return null;
    }
  });

   useEffect(() => {
    if (successMessage && successMessage != '') {
      showAlert('success', successMessage);
      switch (activeTab) {
        case 'meals':
            setIsMealModalOpen(false); dispatch(clearMealMessages());
            break;
        case 'recipes':
            setIsRecipeModalOpen(false); dispatch(clearRecipeMessages());
            break;
        case 'ingredients':
            setIsIngredientModalOpen(false); dispatch(clearIngredientMessages());
            break;
        case 'types':
            setIsTypeModalOpen(false); dispatch(clearTypeMessages());
            break;
        case 'units':
            setIsUnitModalOpen(false); dispatch(clearUnitMessages());
            break;
        default:            
      }
    }
  }, [successMessage]);

  const dispatch = useDispatch(); 

  useEffect(() => {
    dispatch(fetchMeals({ page: 1, searchTerm:'', typeId:typeId  }));
    dispatch(fetchRecipes({ page: 1, searchTerm:'' }));
    dispatch(fetchTypes({ page: 1, searchTerm:'' }));
    dispatch(fetchUnits({ page: 1, searchTerm:'' }));
    dispatch(fetchIngredients({ page: 1, searchTerm:'' }));
  }, [dispatch]);

  const handlePageChangefetchMeals = (page) => {
    dispatch(fetchMeals({ page: page, searchTerm:currentSearchTerm, typeId:typeId }));
  }

  const handleTabChange = (tab) => {    
    var search_field_value = document.getElementById('searchField').value;
    if (search_field_value.length>0) {
      if (activeTab == 'meals') {
        dispatch(fetchMeals({ page: 1, searchTerm:'', typeId:typeId  }));
      }
      if (activeTab == 'recipes') {
        dispatch(fetchRecipes({ page: 1, searchTerm:'' }));
      }
      if (activeTab == 'ingredients') {
        dispatch(fetchIngredients({ page: 1, searchTerm:'' }));
      }
      if (activeTab == 'types') {
        dispatch(fetchTypes({ page: 1, searchTerm:'' }));
      }
      if (activeTab == 'units') {
        dispatch(fetchUnits({ page: 1, searchTerm:'' }));
      }
    }
    setActiveTab(tab);
    closeModal();
  };

  const closeModal = () => {
    setIsMealModalOpen(false);
    setIsRecipeModalOpen(false);
    setIsIngredientModalOpen(false);
    setIsTypeModalOpen(false);
    setIsUnitModalOpen(false);

    setIsEditMode(false);
    setSelectedItem(null);
    setFormData({
      name: '',
      protein: '',
      fats: '',
      carbs: '',
      instructions: '',
      picture: null,
    });

    dispatch(clearMealMessages());
    dispatch(clearRecipeMessages());
    dispatch(clearTypeMessages());
    dispatch(clearUnitMessages());
    dispatch(clearIngredientMessages());
  };

  const handleTypeChange = (event) => {
    if (event.target.value == 'Select menu') {
      setTypeId('');
      dispatch(fetchMeals({ page: 1, searchTerm:'', typeId:''}));
    } else {
      setTypeId(event.target.value);
      dispatch(fetchMeals({ page: 1, searchTerm:'', typeId:event.target.value}));
    }    
  }

  const openCreateModal = (type) => {
    switch (type) {
      case 'meal':
        setIsMealModalOpen(true);
        break;
      case 'recipe':
        setIsRecipeModalOpen(true);
        break;
      case 'ingredient':
        setIsIngredientModalOpen(true);
        break;
      case 'type':
        setIsTypeModalOpen(true);
        break;
      case 'unit':
        setIsUnitModalOpen(true);
        break;
      default:
        break;
    }
    setIsEditMode(false);
    setFormData({
      name: '',
      protein: '',
      fats: '',
      carbs: '',
      instructions: '',
      picture: null,
    });
  };

  const openEditModal = (item, type) => {
    setSelectedItem(item);
    setFormData(item);
    setIsEditMode(true);
    switch (type) {
      case 'meal':
        setIsMealModalOpen(true);
        break;
      case 'recipe':
        setIsRecipeModalOpen(true);
        break;
      case 'ingredient':
        setIsIngredientModalOpen(true);
        break;
      case 'type':
        setIsTypeModalOpen(true);
        break;
      case 'unit':
        setIsUnitModalOpen(true);
        break;
      default:
        break;
    }
  };

  const handleSearch = (searchTerm, activeTab) => {

    setCurrentSearchTerm(searchTerm);
    if (activeTab == 'meals') {
      dispatch(fetchMeals({ page: 1, searchTerm:searchTerm, typeId:typeId}));
    }

    if (activeTab == 'recipes') {
      dispatch(fetchRecipes({ page: 1, searchTerm:searchTerm }));
    }

    if (activeTab == 'ingredients') {
      dispatch(fetchIngredients({ page: 1, searchTerm:searchTerm }));
    }

    if (activeTab == 'types') {
      dispatch(fetchTypes({ page: 1, searchTerm:searchTerm }));
    }

    if (activeTab == 'units') {
      dispatch(fetchUnits({ page: 1, searchTerm:searchTerm }));
    }

  }


  const handlePageChangeFunc = (page, activeTab) => {

    if (activeTab == 'meals') {
      dispatch(fetchMeals({ page: page, searchTerm:currentSearchTerm, typeId:typeId}));
    }

    if (activeTab == 'recipes') {
      dispatch(fetchRecipes({ page: page, searchTerm:currentSearchTerm }));
    }

    if (activeTab == 'ingredients') {
      dispatch(fetchIngredients({ page: page, searchTerm:currentSearchTerm }));
    }

    if (activeTab == 'types') {
      dispatch(fetchTypes({ page: page, searchTerm:currentSearchTerm }));
    }

    if (activeTab == 'units') {
      dispatch(fetchUnits({ page: page, searchTerm:currentSearchTerm }));
    }
  }



  const handlePrint = () => { window.print(); }

  const handleDownloadExcel = (type) => {
    dispatch(exportClients(type));
  };

  return (
    <Layout>
      <div className="container-xxl">
        <div className="row mx-0 p-3 g-3 p-md-4 nav-users-tab">
          <div className="col-md-12">
            <h1 className="title-page">Nutrition</h1>
          </div>
          <div className="col">
            <ul className="nav nav-pills">
              {['meals', 'ingredients', 'types', 'units'].map(tab => (
                <li className="nav-item" key={tab}>
                  <a
                    className={`nav-link ${activeTab === tab ? 'active' : ''}`}
                    onClick={() => handleTabChange(tab)}
                  >
                    {tab.charAt(0).toUpperCase() + tab.slice(1)}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div className="col-12 mt-4">
            <div className="tab-content" id="pills-tabContent">
              {activeTab === 'meals' && (
                <div className="tab-pane active">
                  <ul className="ul-btns-action">
                  <li>
                    <a>
                      <img src={iconPrinter} alt="Print" onClick={handlePrint} />
                    </a>
                  </li>
                  <li>
                    <a onClick={()=>handleDownloadExcel('meals')}>
                      <img src={iconDownload} alt="Download" />
                    </a>
                  </li>
                    <li>
                      <a onClick={() => openCreateModal('meal')} className="add-plus-icon">
                        <img src={iconPlus} alt="Add Meal" />
                      </a>
                    </li>
                  </ul>
                  <SearchField handleSearch={handleSearch} activeTab={activeTab} placeholder="Search Meals..." />

                  <div className="mb-3">
                    <label>Filter By Type</label>
                    <select className="form-select form-select-lg" aria-label="Large select example" onChange={handleTypeChange}>
                      <option selected="">Select menu</option>
                      {mealTypes?.map((mealType) => (
                        <option key={mealType.id} value={mealType.id}>{mealType.title}</option>
                      ))}
                    </select>
                  </div>

                  <MealsTable onEdit={(item) => openEditModal(item, 'meal')} onDelete={(id) => dispatch(deleteMeal(id))}
                  handlePageChange={(page) => handlePageChangeFunc(page, 'meals')}  />
                </div>
              )}
              {activeTab === 'recipes' && (
                <div className="tab-pane active">
                  <ul className="ul-btns-action">
                  <li>
                    <a>
                      <img src={iconPrinter} alt="Print" onClick={handlePrint} />
                    </a>
                  </li>
                  <li>
                    <a onClick={()=>handleDownloadExcel('recipes')}>
                      <img src={iconDownload} alt="Download" />
                    </a>
                  </li>
                    <li>
                      <a onClick={() => openCreateModal('recipe')} className="add-plus-icon">
                        <img src={iconPlus} alt="Add Recipe" />
                      </a>
                    </li>
                  </ul>
                  <SearchField handleSearch={handleSearch} activeTab={activeTab} placeholder="Search Recipes..." />
                  <RecipesTable onEdit={(item) => openEditModal(item, 'recipe')} onDelete={(id) => dispatch(deleteRecipe(id))} 
                  handlePageChange={(page) => handlePageChangeFunc(page, 'recipes')} />
                </div>
              )}
              {activeTab === 'ingredients' && (
                <div className="tab-pane active">
                  <ul className="ul-btns-action">
                  <li>
                    <a>
                      <img src={iconPrinter} alt="Print" onClick={handlePrint} />
                    </a>
                  </li>
                  <li>
                    <a onClick={()=>handleDownloadExcel('ingredients')}>
                      <img src={iconDownload} alt="Download" />
                    </a>
                  </li>
                    <li>
                      <a onClick={() => openCreateModal('ingredient')} className="add-plus-icon">
                        <img src={iconPlus} alt="Add Ingredient" />
                      </a>
                    </li>
                  </ul>
                  <SearchField handleSearch={handleSearch} activeTab={activeTab} placeholder="Search Ingredients..." />
                  <IngredientsTable onEdit={(item) => openEditModal(item, 'ingredient')} onDelete={(id) => dispatch(deleteIngredient(id))}
                  handlePageChange={(page) => handlePageChangeFunc(page, 'ingredients')} />
                </div>
              )}
              {activeTab === 'types' && (
                <div className="tab-pane active">
                  <ul className="ul-btns-action">
                  <li>
                    <a>
                      <img src={iconPrinter} alt="Print" onClick={handlePrint} />
                    </a>
                  </li>
                  <li>
                    <a onClick={()=>handleDownloadExcel('meal_types')}>
                      <img src={iconDownload} alt="Download" />
                    </a>
                  </li>
                    <li>
                      <a onClick={() => openCreateModal('type')} className="add-plus-icon">
                        <img src={iconPlus} alt="Add Type" />
                      </a>
                    </li>
                  </ul>
                  <SearchField handleSearch={handleSearch} activeTab={activeTab} placeholder="Search Meal Types..." />
                  <TypesTable onEdit={(item) => openEditModal(item, 'type')} onDelete={(id) => dispatch(deleteType(id))} 
                  handlePageChange={(page) => handlePageChangeFunc(page, 'types')} />
                </div>
              )}
              {activeTab === 'units' && (
                <div className="tab-pane active">
                  <ul className="ul-btns-action">
                  <li>
                    <a>
                      <img src={iconPrinter} alt="Print" onClick={handlePrint} />
                    </a>
                  </li>
                  <li>
                    <a onClick={()=>handleDownloadExcel('units')}>
                      <img src={iconDownload} alt="Download" />
                    </a>
                  </li>
                    <li>
                      <a onClick={() => openCreateModal('unit')} className="add-plus-icon">
                        <img src={iconPlus} alt="Add Unit" />
                      </a>
                    </li>
                  </ul>
                  <SearchField handleSearch={handleSearch} activeTab={activeTab} placeholder="Search Units..." />
                  <UnitTable onEdit={(item) => openEditModal(item, 'unit')} onDelete={(id) => dispatch(deleteUnit(id))} 
                  handlePageChange={(page) => handlePageChangeFunc(page, 'units')} />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {isMealModalOpen && <MealModal isOpen={isMealModalOpen} closeModal={closeModal} initialData={formData} isEditMode={isEditMode} />}
      {isRecipeModalOpen && <RecipeModal isOpen={isRecipeModalOpen} closeModal={closeModal}  initialData={formData} isEditMode={isEditMode} />}
      {isIngredientModalOpen && <IngredientModal isOpen={isIngredientModalOpen}  closeModal={closeModal}  initialData={formData} isEditMode={isEditMode}/>}
      {isTypeModalOpen && <TypeModal isOpen={isTypeModalOpen} closeModal={closeModal}  initialData={formData} isEditMode={isEditMode} />}
      {isUnitModalOpen && <UnitModal isOpen={isUnitModalOpen} closeModal={closeModal} initialData={formData} isEditMode={isEditMode} />}
    </Layout>
  );
};

export default Nutritions;